import { Component } from '@angular/core';

@Component({
  selector: 'icon-pause',
  standalone: true,
  template: `
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pause-icon lucide-pause">
        <rect x="14" y="3" width="5" height="18" rx="1"/>
        <rect x="5" y="3" width="5" height="18" rx="1"/>
        </svg> -->
    <svg width="88" height="48" viewBox="0 0 88 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 24C0 10.7452 10.7452 0 24 0H64C77.2548 0 88 10.7452 88 24C88 37.2548 77.2548 48 64 48H24C10.7452 48 0 37.2548 0 24Z" fill="#1C6E70"/>
      <mask id="mask0_26_1133" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="32" y="12" width="24" height="24">
        <rect x="32" y="12" width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_26_1133)">
        <path d="M46 31V17H50V31H46ZM38 31V17H42V31H38Z" fill="white"/>
      </g>
    </svg>
  `,
    styles: [`
    svg {
        path {
          fill: var(--main-color);
        }
        g {
          path{
            fill: white;
          }
        }
    }

    svg:hover {
        path {
          fill: var(--main-color-strong);
        }
        g {
          path{
            fill: #0B2C2D;
          }
        }
    }

      svg:active {
        path {
          fill: #000;
        }
        g {
          path{
            fill: white;
          }
        }
    }

  `]
})

export class PauseIconComponent {

}
